import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBMXAuthenticationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  position: 'absolute',
  width: '100%',
  padding: '1rem',
  zIndex: 1,
  background: theme.palette.custom.cameraTitle,
  color: theme.palette.common.white,
}));

export const StyledBMXCameraContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  height: '100%',
}));

export const StyledUserMessage = styled(Box)(({ theme }) => ({
  position: 'absolute',
  color: theme.palette.text.primary,
  width: '100%',
  padding: '1rem',
  bottom: '1rem',
  zIndex: 3,
  textAlign: 'center',
}));

export const StyledReloadIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  color: theme.palette.common.white,
  padding: '1rem',
  bottom: '5rem',
  zIndex: 3,
  background: 'transparent',
  border: 'none',
}));
